const ITEMS_FALLBACK = ["Exclusive Access", "Unlisted Assets", "Absolute Confidentiality", "Tailored Service", "International Network", "Rare Opportunities"];

import { useI18n } from "../context/I18nContext";

export const Marquee = () => {
  const { t } = useI18n();
  const items = t("marquee");
  const arr = Array.isArray(items) ? items : ITEMS_FALLBACK;
  const loop = [...arr, ...arr];
  return (
    <div data-testid="marquee" className="bg-navy border-y border-white/10 py-8 overflow-hidden">
      <div className="flex whitespace-nowrap marquee-track animate-marquee">
        {loop.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-serif italic text-white/85 text-3xl md:text-5xl px-8">{item}</span>
            <span className="text-gold text-2xl">&#8226;</span>
          </div>
        ))}
      </div>
    </div>
  );
};
